(function ($, window, document) {

    // on document ready
    $(function () {

        //#region Variables =======================================================================

        var $window = $(window);
        var $document = $(document);
        var $body = $('body');
        var $links = $('.main-navbar__links');
        var $linksTopLevel = $('.nav-links__list-entries--level-0.nav-links__list-entries--main-links');
        var $btnMenu = $('.main-navbar__btn--menu');
        var $icon = $btnMenu.find('.icon-svg_navi-burger');
        var $breadcrumbs = $('.bes-breadcrumb__list');
        var $linksWithEntries = $('.nav-item__link.has-entries');
        var $toggleIcons = $linksWithEntries.find('.nav-item__icon');
        var $noHover = $('.bes-page-header__no-hover-indicator');
        var $search = $('.main-navbar__search');
        var $searchForm = $('.main-navbar__search-form');
        var $searchInput = $('.main-navbar__search input');
        var $searchSubmit = $('.main-navbar__search-submit');
        var searchHiddenClass = 'main-navbar__search--hidden';
        var tResize;
        var $navItems = $('.nav-item');
        var $predictiveSearchResult = $('.main-navbar .predictiveSearchResults');

        //#endregion

        //#region Functions =======================================================================

        function showMenu() {
            $links.removeClass('d-none');
            //$links.removeClass('hidden-sm');
            $icon.removeClass('icon-svg_navi-burger');
            $icon.addClass('icon-svg_navi-close');
            $breadcrumbs.addClass('invisible');
            $body.addClass('is-menu-open');
        }

        function hideMenu() {
            $links.addClass('d-none');
            //$links.addClass('hidden-sm');
            $icon.addClass('icon-svg_navi-burger');
            $icon.removeClass('icon-svg_navi-close');
            $breadcrumbs.removeClass('invisible');
            $body.removeClass('is-menu-open');
            $linksWithEntries.removeClass('is-toggled');
        }

        // set dttg for touch only clients on md+ viewport sizes
        function initDoubleTabToGo() {
            if (!$noHover.is(":visible")) {
                return;
            }
            $linksTopLevel.doubleTapToGo();
        }

        function showSearch() {
            if (!$search.hasClass(searchHiddenClass)) {
                return;
            }
            $search.removeClass(searchHiddenClass);
            $predictiveSearchResult.removeClass('d-none');
            $searchInput.focus();
            $search.off('click');
            $searchSubmit.on('click', function () { $searchForm.submit(); });
        }

        function hideSearch() {
            if ($search.hasClass(searchHiddenClass)) {
                return;
            }
            $search.addClass(searchHiddenClass);
            $predictiveSearchResult.addClass('d-none');
            $searchSubmit.off('click');
            $search.on('click', function () { showSearch(); });
        }

        //#endregion

        //#region Handler =========================================================================

        // mobile menu toggler
        $btnMenu.click(function ()
        {
            // if hidden, show it
            if ($links.hasClass('d-none')) {
                showMenu();
            }
            // if shown, hide it
            else {
                hideMenu();
            }
        });

        // toggle navigation
        $toggleIcons.click(function (e) {
            // cancel click
            e.preventDefault();
            // open menu
            var $link = $(this).parent();
            if (!$link.hasClass('is-toggled')) {
                $link.addClass('is-toggled');
            }
            else {
                $link.removeClass('is-toggled');
            }
        });

        // ----------------------------------------------------------------------------------------
        // Delay for main navigation for better user experience when moving mouse to sublink
        // ----------------------------------------------------------------------------------------

        // const for timeout in milliseconds
        const timeoutTime = 300;

        // set hovered class for display:block delay
        $navItems.on('mouseover', function () {
            const $this = $(this);

            // if there is any sibling or any child of siblings with --hovered class, 
            // than wait timeoutTime before set the --hovered class.
            // Only level 1, other levels do not need this.
            // Otherwise the sub items will be opend both at the same time and overlap each other.
            if ($this.hasClass('nav-item--level-1') 
                && $this.parent().find('.nav-item--hovered').length)
            {
                let timeout = setTimeout(function () {
                    // Check again and do not set if another sibling is now hovered.
                    // This happens when moving over elements but end with hover on
                    // another siblings sub items
                    if (!$this.parent().find('.nav-item--hovered').length)
                    {
                        $this.addClass('nav-item--hovered');
                    }
                }, timeoutTime);
            }

            // if not, do not wait timeout, set instant
            else
            {
                $this.addClass('nav-item--hovered');
            }
        });

        // remove hovered class for display:block delay
        $navItems.on('mouseleave', function () {
            const $this = $(this);

            // do not wait for timeout in top level, remove instant and exit
            if ($this.hasClass('nav-item--level-0'))
            {
                $this.removeClass('nav-item--hovered');
                return;
            }

            // in other levels wait timeout before remove --hovered class
            let timeout = setTimeout(function () {

                // only remove class if no child is hovered
                if($this.find('.nav-item--hovered').length === 0) {
                    $this.removeClass('nav-item--hovered');
                }
            }, timeoutTime);
        });

        // ----------------------------------------------------------------------------------------

        // show search if clicked
        $search.on('click', function () { showSearch(); });

        // hide search if clicked outside
        $document.on('click', function (e) {
            var $target = $(e.target);
            if ($target.closest('.main-navbar__search').length === 0) {
                hideSearch();
            }
        });

        // hide menu on window resize
        $window.on('resize', function ()
        {
            var newWidth = $("body").width();
            clearTimeout(tResize);
            tResize = setTimeout(function () {
                if ($body.width() !== newWidth) {
                    hideMenu();
                    hideSearch();
                    initDoubleTabToGo();
                }
            }, 100);
        });

        //#endregion

        // execute when page is loaded
        hideMenu();
        hideSearch();
        initDoubleTabToGo();
    });

})(window.jQuery, window, document);